import { firestoreService } from "../db/FirestoreService";

export type FAQ = {
  id: string;
  question: string;
  answer: string;
  order?: number;
  tags?: string[];
};

class ContentService {
  private static instance: ContentService;
  private faqsCache: FAQ[] | null = null;

  static getInstance(): ContentService {
    if (!ContentService.instance) {
      ContentService.instance = new ContentService();
    }
    return ContentService.instance;
  }

  /**
   * Get FAQs from Firestore
   */
  async getFaqs(forceRefresh = false): Promise<FAQ[]> {
    if (!forceRefresh && this.faqsCache) {
      return this.faqsCache;
    }

    try {
      const faqDocs = await firestoreService.queryCollection(
        'faqs',
        [],
        { field: 'order', direction: 'asc' }
      );

      this.faqsCache = faqDocs.map(doc => ({
        id: doc.id,
        question: doc.question as string,
        answer: doc.answer as string,
        order: doc.order as number | undefined,
        tags: doc.tags as string[] | undefined
      }));

      return this.faqsCache;
    } catch (error) {
      console.error('Failed to load FAQs:', error);
      return [];
    }
  }

  /**
   * Clear cache
   */
  clearCache(): void {
    this.faqsCache = null;
  }
}

export const contentService = ContentService.getInstance();
